import styled from 'styled-components'

import { BREAKPOINTS } from 'resources'
import { reklaimScribbleBg } from 'resources/images'

const ScribbleBackground = styled.div`
  background-image: url(${reklaimScribbleBg});
  background-size: auto 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-attachment: fixed;
  flex-grow: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 16px;

  @media (min-width: ${BREAKPOINTS.sm}) {
    padding: 25px 30px;
  }
`

export default ScribbleBackground
